import api from "../../../shared/api/apiClient";

export const tenantControlApi = {
  async listTenants() {
    const { data } = await api.get("/api/system/tenants");
    return data;
  },

  async getTenant(id) {
    const { data } = await api.get(`/api/system/tenants/${id}`);
    return data;
  },

  async createTenant(payload) {
    const { data } = await api.post("/api/system/tenants", payload);
    return data;
  },

  async updateTenant(id, payload) {
    const { data } = await api.put(`/api/system/tenants/${id}`, payload);
    return data;
  },

  async deleteTenant(id) {
    const { data } = await api.delete(`/api/system/tenants/${id}`);
    return data;
  },

  async getTenantStats(id) {
    const { data } = await api.get(`/api/system/tenants/${id}/stats`);
    return data;
  },

  async getTenantUsage(id) {
    const { data } = await api.get(`/api/system/tenants/${id}/usage`);
    return data;
  },

  async listDomains(tenantId) {
    const { data } = await api.get(`/api/system/tenants/${tenantId}/domains`);
    return data;
  },

  async addDomain(tenantId, payload) {
    const { data } = await api.post(
      `/api/system/tenants/${tenantId}/domains`,
      payload
    );
    return data;
  },

  async deleteDomain(domainId) {
    const { data } = await api.delete(`/api/system/tenants/domains/${domainId}`);
    return data;
  },

  async listPlans() {
    const { data } = await api.get("/api/system/plans");
    return data;
  },

  async createPlan(payload) {
    const { data } = await api.post("/api/system/plans", payload);
    return data;
  },

  async updatePlan(id, payload) {
    const { data } = await api.put(`/api/system/plans/${id}`, payload);
    return data;
  },

  async deletePlan(id) {
    const { data } = await api.delete(`/api/system/plans/${id}`);
    return data;
  },

  async listBusinessPresets() {
    const { data } = await api.get("/api/system/business-presets");
    return data;
  },

  async getBusinessPreset(key) {
    const { data } = await api.get(`/api/system/business-presets/${key}`);
    return data;
  },

  async applyBusinessPreset(payload) {
    const { data } = await api.post("/api/system/business-presets/apply", payload);
    return data;
  },
};